
import {  Component,FormPageMixins,Mixins,appConst,PageResultModalMixins,$util } from "@/lib";
import Factorycost from "@/store/modules/shipment/factorycost/entity";
import CardTitleView from "@/components/card-title/index.vue"
@Component({
    components:{CardTitleView}
})
export default class DetailFactorycostView extends  Mixins(FormPageMixins, PageResultModalMixins) {
     model:Factorycost = new Factorycost();
     securityItem:any;//选项明细集合（弹框用）
async created() {

            Object.assign(this.config,{
            getAction: "shipment/factorycost/get",
           //  labelWidth:220,
            pageTitleL:"app.FactoryCost.Registration",
            isRedirectIndex:true

        })
  }
  get record(){
        return this.$store.state.shipment.factorycost.editFactoryCost;
    }
    get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
    securityColumn = [
        {
            title: this.L('app.FactoryCost.SerialNumber'),
            slot: 'serialNumber',
            key:"serialNumber",
            width: 100
          },
          {
            title: this.L('app.FactoryCost.FactoryName'),
            slot: 'factoryName',
            key:"factoryName",
            minwidth: 120
          },
          {
                title: this.L("app.FactoryCost.Amount"),
                key: "amount",
                width: 150,
                render: (h: any, params: any) => {
                return [h("span", this.$util.format.amount(params.row.amount))];
                },
          },
          {
            title: this.L('app.FactoryCost.Remark'),
            slot: 'remark',
            key:"remark",
          },
    ];
    handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.FactoryCost.SubTotal');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0||index===3 ||index===4||index===5 ) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            sums[key] = {
                key,
                value: key === "amount" ? this.$util.format.amount(v) : v
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }
    
  
}

